import useSWR from 'swr';
import { useConfigurationContext } from '../contexts/ConfigurationContext';
import { fetcher } from '../helpers/fetcher';

async function fetchLocalization(url, tenant) {
  var locale = document.documentElement.lang;
  var response = await fetcher(url, {
    headers: {
      'Accept-Language': locale
    },
    tenant: tenant,
    identityUrl: '',
    customerId: 0
  });
  var Translations = response.Translations,
      DefaultLanguage = response.DefaultLanguage,
      Contents = response.Contents;
  var currentLocale = locale.length > 0 ? locale : DefaultLanguage;

  if (!currentLocale) {
    return undefined;
  }

  return {
    translations: Translations[currentLocale],
    locale: currentLocale || '',
    contents: Contents[currentLocale]
  };
}

export function useLocalizationQuery() {
  var _useConfigurationCont = useConfigurationContext(),
      tenant = _useConfigurationCont.tenant,
      staticApiUrl = _useConfigurationCont.staticApiUrl;

  return useSWR("".concat(staticApiUrl, "/tenants/").concat(tenant, "/applications/loginSidebar/localization"), async function (url) {
    return fetchLocalization(url, tenant);
  });
}